import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.css';
import HomePage from './Pages/Home';
import ServicePage from './Pages/Services';




const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/services">
          <ServicePage />
        </Route>
        <Route path="/">
          <HomePage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
